export const PROPERTY_APT_RESIDENT_sv = {
  translation: {
    keys: {
      condominium: 'Fastighet',
      handoverInstructions: 'Instruktioner för nyckelöverlämning',
      handoverInstructionsPlaceholder: 'Skriv instruktioner för nyckelöverlämning och återlämning',
    },
    key: {
      handoverAddFromDirectory: 'Via fastighet eller lägenhet',
      handoverDirectoryHint:
        'Välj fastighet eller lägenhet, eller skriv minst två tecken i sökfältet (stämpel, adress, fastighet).',
      handoverDirectoryNoQuery: 'Välj fastighet eller lägenhet, eller skriv minst 2 tecken för att söka.',
    },
    apartments: {
      apartment: 'Lägenhet',
      condominium: 'Fastighet',
      selectCondominium: 'Välj fastighet',
      condominiumRequired: 'Fastighet krävs',
    },
    validation: {
      condominiumRequired: 'Fastighet krävs',
    },
    wizard: {
      title: 'Snabbinstallation av fastighet',
      subtitle: 'Skapa fastighet, lägenheter, boende och nycklar på en gång',
      steps: {
        condominium: 'Fastighet',
      },
      stepDescriptions: {
        condominium: 'Skapa en ny fastighet genom att fylla i grunduppgifterna',
        apartments: 'Lägg till lägenheter i fastigheten individuellt eller i bulk',
      },
    },
    condominium: {
      header: 'Fastigheter',
      condominiums: 'Fastigheter',
      condominiumDetails: 'Fastighetsuppgifter',
      name: 'Fastighet',
      create: 'Skapa fastighet',
      edit: 'Redigera fastighet',
      update: 'Uppdatera fastighet',
      deleteTitle: 'Ta bort fastighet',
      deleteMessage: 'Vill du verkligen ta bort fastigheten',
      searchPlaceholder: 'Sök fastigheter...',
      nocondominiumsForSearch: 'Inga fastigheter för sökningen "{{searchTerm}}"',
      nocondominiumsYet: 'Inga fastigheter.',
      selectCondominium: 'Välj fastighet',
      transfer: {
        toSubCompany: 'Överför till dotterbolag',
        transferredTooltip: 'Överförd till dotterbolag',
        transferredTo: 'Överförd till {{name}}',
        subCompanyCanEdit: 'Dotterbolaget kan redigera överförda data',
        revokeTransfer: 'Återkalla överföring',
        changeEditAccess: 'Ändra redigeringsåtkomst',
        selectSubCompany: 'Välj dotterbolag',
        confirmTransfer: 'Bekräfta överföring',
        transferSuccess: 'Överföring genomförd',
        revokeConfirm:
          'Är du säker på att du vill återkalla överföringen? Dotterbolaget förlorar åtkomst till fastigheten.',
        transferredAt: 'Överförd',
        back: 'Tillbaka',
        next: 'Nästa',
      },
    },
    controlPanel: {
      transferredCondominiums: 'Överförda fastigheter',
      personalDataPurge: {
        targetsHint: 'Personer är förvalda. Lägg till fastigheter, lägenheter och nycklar vid behov.',
        propertyGroupHint: 'Fastigheter, lägenheter och nycklar hamnar i samma papperskorg i 7 dagar.',
        targetTypes: {
          condominium: 'Fastigheter',
        },
        fields: {
          condominiumId: 'Fastighet',
        },
        columns: {
          condominium: 'Fastighet',
        },
      },
    },
    messages: {
      condominiumCreated: 'Fastighet skapad',
      condominiumUpdated: 'Fastighet uppdaterad',
      condominiumDeleted: 'Fastighet borttagen',
      condominiumsDeletedBulk: '{{count}} fastigheter har tagits bort',
      condominiumCreateFailed: 'Misslyckades med att skapa fastighet',
      condominiumUpdateFailed: 'Misslyckades med att uppdatera fastighet',
      condominiumDeleteFailed: 'Misslyckades med att ta bort fastighet',
    },
    dashboard: {
      myManagedProperties: 'Fastigheter jag hanterar',
      noProperties: 'Inga fastigheter att visa',
    },
    properties: {
      tabProperties: 'Fastigheter',
      tabApartments: 'Lägenheter',
      createProperty: 'Skapa fastighet',
    },
    general: {
      showBulkDelete: 'Visa massradering i tabeller',
      showBulkDeleteDescription:
        'Aktivera val och borttagning av flera objekt i tabeller för lägenheter, boende, fastigheter och nycklar.',
    },
    actions: {
      bulk: {
        deleteCondominiumsMessage: 'Är du säker på att du vill ta bort {{count}} valda fastigheter?',
        editCondominiumsTitle: 'Redigera fastigheter',
      },
    },
    tooltips: {
      keys: {
        handoverInstructions:
          'Visas vid nyckelöverlämning och återlämning. Du kan ange instruktioner på företags-, fakturerings-, fastighets- och lägenhetsnivå; lägre nivå ersätter högre nivå.',
      },
      wizard: {
        superintendent: 'Förvaltaren är personen som ansvarar för fastighetens dagliga förvaltning och underhåll.',
      },
      condominium: {
        businessId: 'Finskt FO-nummer i formatet 1234567-8. Valfritt, men rekommenderas för officiella fastigheter.',
      },
      settings: {
        showMyProperties: 'Visa fastigheter där du är listad som förvaltare eller har särskilda rättigheter.',
        showBulkDelete:
          'Aktivera val och borttagning av flera objekt i tabeller (lägenheter, boende, fastigheter, nycklar).',
      },
    },
    import: {
      condominiums: 'Fastigheter',
      condominiumsInstructions: 'Importera fastigheter',
      apartmentsInstructionsDescription: 'Adress och fastighet är obligatoriska uppgifter.',
      apartmentsFieldCondominium: 'Fastighet: Namn på en befintlig fastighet',
      keysFieldCondominium: 'Fastighet: Namn på en befintlig fastighet (endast för huvudnycklar)',
      errors: {
        condominiumNotFound: 'Hittades inte',
        condominiumRequiredForGeneral: 'Fastighet krävs för huvudnyckeltyper',
        condominiumNotAllowedForNonGeneral: 'Fastighet kan inte anges för icke-huvudnyckeltyper',
      },
    },
    invitations: {
      condominium: 'Fastighet',
      apartment: 'Lägenhet',
    },
    contractor: {
      property: 'Fastighet',
      apartment: 'Lägenhet',
      selectProperty: 'Välj fastighet',
      selectApartment: 'Välj lägenhet',
      keyAccessFilterCondominiumPlaceholder: 'Alla fastigheter',
      keyAccessFilterApartmentPlaceholder: 'Alla lägenheter',
    },
    contractorDashboard: {
      properties: 'Fastigheter',
      apartments: 'Lägenheter',
    },
    documentBank: {
      searchPlaceholder: 'Sök efter fastighet, lägenhet eller faktureringskonto…',
      sections: {
        condominiums: 'Fastigheter',
      },
    },
    events: {
      entityType: {
        resident: 'Boende',
        apartment: 'Lägenhet',
        condominium: 'Fastighet',
        key: 'Nyckel',
        landlord: 'Hyresvärd',
      },
    },
    reports: {
      totalCondominiums: 'Fastigheter',
    },
    billing: {
      auditCondominium: 'Fastigheter',
      auditApartment: 'Lägenheter',
      auditResident: 'Boende',
      auditKey: 'Nycklar',
    },
    landlordPortal: {
      allApartmentsOption: 'Alla lägenheter',
    },
    residentNotifications: {
      scope: {
        wholeCondominium: 'Hela fastigheten',
      },
      field: {
        wholeCondominium: 'Hela fastigheten',
        wholeCondominiumHelp: 'Syns för alla lägenheter under fastigheten i boende- och hyresvärdportalerna.',
      },
      validation: {
        apartments: 'Välj minst en lägenhet eller hela fastigheten.',
      },
    },
    maintenance: {
      needsAssessment: {
        selectCondominium: 'Välj fastighet för att filtrera listan.',
      },
    },
    upkeep: {
      selectCondominiums: 'Välj fastigheter',
      multiBatchAllApartmentsHelp: 'Skapar rader för alla lägenheter i varje vald fastighet.',
      filterCondominiums: 'Filtrera fastigheter',
      filterCondominiumsPlaceholder: 'Ange fastighetsnamn eller adress',
      sendResidentNotificationHelp: 'Samma meddelande skickas till boende i valda fastigheter (och visas i portaler).',
      wizardStepLocationHelp:
        'Välj fastighet och vid behov lägenhet. Om ingen lägenhet väljs kan du välja flera lägenheter samtidigt.',
      wizardStepLocationHelpEquipment:
        'Välj fastighet och vid behov lägenhet. Om ingen lägenhet väljs väljer du lägenheter tillsammans med enheter i nästa steg.',
      locationProperty: 'Fastighet',
      locationSpace: 'Lägenhet',
      trackedAssetsEmpty: 'Inga enheter för vald fastighet',
      noApartmentsForProperty: 'Fastigheten har inga lägenheter',
    },
    trackedAssets: {
      columnCondominium: 'Fastighet',
      filterCondominium: 'Filtrera fastighet',
      selectCondominium: 'Välj fastighet',
      mapEmptyHint: 'Koppla utrustningen till en fastighet eller lägenhet som har en adress.',
      bulkCreateUpkeepSameCondo: 'Välj endast enheter från samma fastighet.',
    },
    residentPortal: {
      filesSectionTitle: 'Lägenhetens och fastighetens filer',
    },
  },
};
